function translate_external_status(status){
    if(status === 'unavailable') return 'Vor Planung';
    else if(status === 'empty') return 'Angebot anfordern';
    else if(status === 'checkout') return 'Wartend';
    else if(status === 'submitted') return 'Erhalten';
    else if(status === 'overdue') return 'Angebot fehlt';
    return status
}

export default translate_external_status;